// extracted by mini-css-extract-plugin
export var active = "_6j-a";
export var activeIndicator = "_6j-8";
export var animate = "_6j-9";
export var disabled = "_6j-b";
export var fullWidth = "_6j-2";
export var lg = "_6j-7";
export var md = "_6j-6";
export var redoButtonTabGroup = "_6j-0";
export var sm = "_6j-5";
export var tabButton = "_6j-3";
export var tabButtonsContainer = "_6j-1";
export var xs = "_6j-4";